import React from 'react'

export default class ErrorBoundary extends React.Component {
  state = {
    error: null,
  }

  componentDidCatch(error) {
    this.setState({ error })
  }

  render() {
    const { error } = this.state
    const { children } = this.props
    if (error) {
      return (
        <div>
          <h1>Something went wrong.</h1>
          <div>{error.message}</div>
        </div>
      )
    }
    return children
  }
}
